import React, { useState } from 'react';
import { useAuth } from '../../context/auth';
import { useFieldValidation, validateEmail } from '../../utils/validation';
import FormInput from './FormInput';
import './Auth.css';

export default function ForgotPassword() {
  const [formError, setFormError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  // Field validation hook
  const emailField = useFieldValidation('', validateEmail);

  async function handleSubmit(e) {
    e.preventDefault();

    // Validate email field
    if (!emailField.isValid) {
      setFormError('Please enter a valid email address');
      return;
    }

    try {
      setMessage('');
      setFormError('');
      setLoading(true);
      await resetPassword(emailField.value);
      setMessage('Check your inbox for further instructions');
    } catch (error) {
      setFormError('Failed to reset password: ' + error.message);
    }
    setLoading(false);
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Password Reset</h2>
        {formError && <div className="auth-error">{formError}</div>}
        {message && <div className="auth-success">{message}</div>}
        
        <form onSubmit={handleSubmit}>
          <FormInput
            label="Email"
            type="email"
            value={emailField.value}
            onChange={emailField.setValue}
            onBlur={emailField.handleBlur}
            error={emailField.error}
            touched={emailField.touched}
            required
            autoComplete="email"
            placeholder="Enter your email address"
          />
          
          <button disabled={loading} type="submit" className="auth-button">
            {loading ? 'Sending...' : 'Reset Password'}
          </button>
        </form>
        
        <div className="auth-links">
          <a href="/login">Back to Sign In</a>
        </div>
      </div>
    </div>
  );
} 